import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { LuGlobe2 } from 'react-icons/lu';
import { useThemeContext } from 'src/context/ThemeProvider';
import { UIUser } from 'types';
import ProfileActions from './ProfileActions';

const ProfileSocial = ({
	userProfileInfo,
	isSelf,
	showBannerBg,
}: {
	userProfileInfo: UIUser;
	isSelf: boolean;
	showBannerBg: boolean;
}) => {
	const { themeMode } = useThemeContext();
	return (
		<div className="flex items-center flex-wrap justify-between">
			<div className="flex items-center gap-3 md:gap-4">
				{userProfileInfo.profile.linkedInProfile ? (
					<div
						className="cursor-pointer"
						onClick={() => {
							window.open(userProfileInfo.profile.linkedInProfile, '_blank');
						}}
					>
						<BsLinkedin color="#3E7BFA" className="w-[16px] h-[16px] md:w-[24px] md:h-[24px]" />
					</div>
				) : null}
				{userProfileInfo.profile.githubURL ? (
					<div
						className="cursor-pointer"
						onClick={() => {
							window.open(userProfileInfo.profile.githubURL, '_blank');
						}}
					>
						<BsGithub className="w-[16px] h-[16px] md:w-[24px] md:h-[24px]" />
					</div>
				) : null}
				{userProfileInfo.profile.portfolioLink ? (
					<div
						className="cursor-pointer"
						onClick={() => {
							window.open(userProfileInfo.profile.portfolioLink, '_blank');
						}}
					>
						<LuGlobe2
							className="w-[16px] h-[16px] md:w-[24px] md:h-[24px]"
							color={themeMode === 'dark' ? '#E4E4EB' : '#7777E7'}
						/>
					</div>
				) : null}
			</div>
			<div className="md:hidden">
				<ProfileActions userProfileInfo={userProfileInfo} isSelf={isSelf} showBannerBg={showBannerBg} />
			</div>
		</div>
	);
};

export default ProfileSocial;
